export enum RealtimeType {
    azureTaskSorting = 'azureTaskSorting',
    checkpoints = 'checkpoints',
    checkpoint_results = 'checkpointResults',
    companies = 'companies',
    leaves = 'leaves',
    platforms = 'platforms',
    users = 'users',
}
